import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaSearch, FaArrowRight } from 'react-icons/fa';
import { LuPiano } from "react-icons/lu";
import SeoHead from '../components/Menu/components/SeoHead';
import '../assets/css/pianosList.css';

const PianosList = () => {
  const [pianos, setPianos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPianos = async () => {
      try {
        const response = await fetch('https://pianoswaldir.com.br/api/pianos.php?action=list');
        const data = await response.json();
        setPianos(data);
        setLoading(false);
      } catch (error) {
        console.error('Erro ao carregar pianos:', error);
        setLoading(false);
      }
    };

    fetchPianos();
  }, []);

  // Schema para listagem de produtos
  const itemListSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": pianos.map((piano, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "item": {
        "@type": "Product",
        "name": `${piano.marca} ${piano.modelo}`,
        "url": `https://pianoswaldir.com.br/pianos/${piano.id}`,
        "image": piano.foto_principal,
        "offers": {
          "@type": "Offer",
          "priceCurrency": "BRL",
          "price": piano.valor,
          "availability": piano.status === 'disponivel' ? 
            "https://schema.org/InStock" : "https://schema.org/OutOfStock"
        }
      }
    }))
  };

  if (loading) {
    return (
      <div className="loading-container">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
          className="loading-spinner"
        >
          <LuPiano size={32} />
        </motion.div>
        <p>Carregando nossa coleção de pianos...</p>
      </div>
    );
  }

  return (
    <div className="container">
<SeoHead
  title="Pianos à Venda | Coleção de Pianos Usados e Restaurados | Waldir Pianos"
  description="Descubra a coleção completa de pianos à venda na Waldir Pianos: pianos de cauda, verticais, marcas renomadas como Yamaha, Kawai, Steinway e mais. Instrumentos usados, revisados e com garantia."
  keywords="pianos à venda, pianos usados, pianos restaurados, comprar piano, piano vertical, piano de cauda, Waldir Pianos, pianos SP, Yamaha, Kawai, Steinway, pianos revisados"
  url="https://pianoswaldir.com.br/pianos" 
  canonicalUrl="https://pianoswaldir.com.br/pianos"
  schemaMarkup={itemListSchema}
/>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="pianos-list-container"
      >
        <div className="pianos-list-header">
          <motion.h1 
            initial={{ y: -20 }}
            animate={{ y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Nossa Coleção de Pianos
          </motion.h1>
          <p>Descubra os instrumentos que fazem história</p>
        </div>

        {pianos.length === 0 ? (
          <div className="no-pianos">
            <LuPiano size={48} />
            <p>Nenhum piano disponível no momento</p>
          </div>
        ) : (
          <div className="pianos-grid">
            {pianos.map((piano, index) => (
              <motion.div
                key={piano.id}
                className="piano-card"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                whileHover={{ y: -5, boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}
                itemScope
                itemType="https://schema.org/Product"
              >
                <Link to={`/pianos/${piano.id}`} className="piano-link" itemProp="url">
                  <div className="piano-image-container">
                    <img 
                      src={piano.foto_principal} 
                      alt={`${piano.marca} ${piano.modelo}`}
                      className="piano-image"
                      itemProp="image"
                    />
                    <div className="piano-overlay">
                      <FaSearch size={24} />
                      <span>Ver Detalhes</span>
                    </div>
                  </div>
                  <div className="piano-info">
                    <h3 itemProp="name">{piano.marca} {piano.modelo}</h3>
                    <div className="piano-meta">
                      <span className="piano-price" itemProp="offers" itemScope itemType="https://schema.org/Offer">
                        <span itemProp="priceCurrency" content="BRL"></span>
                        <span itemProp="price" content={piano.valor}>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                          }).format(piano.valor)}
                        </span>
                      </span>
                      <span className="piano-link-text">
                        Ver mais <FaArrowRight />
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default PianosList;